// blogApi.js
// Blog post service module for fetching and creating blog content
// Provides functions for listing all posts, fetching individual posts, and creating new posts
// Blog creation requires authentication

import apiRequest from './api';

// Fetches all blog posts from the server
// Returns array of blog post objects
export async function getAllBlogs() {
  return apiRequest('/Blog', { method: 'GET' });
}

// Fetches a single blog post by ID
// Returns blog post object with full content
export async function getBlog(id) {
  return apiRequest(`/Blog/${id}`, { method: 'GET' });
}

// Creates a new blog post (requires authentication)
// Parameters: blog object with post data, idToken for authorization
// Returns created blog post with generated ID
export async function createBlog(blog, idToken) {
  return apiRequest('/Blog', {
    method: 'POST',
    headers: { Authorization: `Bearer ${idToken}` },
    body: JSON.stringify(blog),
  });
}

// Updates an existing blog post (requires authentication)
// Parameters: blog ID, blog object with updated data, idToken for authorization
export async function updateBlog(id, blog, idToken) {
  return apiRequest(`/Blog/${id}`, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${idToken}` },
    body: JSON.stringify(blog),
  });
}

// Deletes a blog post (requires authentication)
// Parameters: blog ID, idToken for authorization
export async function deleteBlog(id, idToken) {
  return apiRequest(`/Blog/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${idToken}` },
  });
}
